// extracted by mini-css-extract-plugin
export default {"icons":"LoginIcon_icons__ngaeX","icons_auth":"LoginIcon_icons_auth__2yrCa"};